import { APP_ROUTES } from '../../common/globalConstants';
import { UserManagement } from './';

export default {
  path: `/${APP_ROUTES.DASHBOARD}/${APP_ROUTES.USER_MANAGEMENT}`,
  name: 'User Management',
  childRoutes: [
    {
      path: APP_ROUTES.USER_MANAGEMENT,
      name: 'User Management',
      component: UserManagement,
      isIndex: true,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/features/user-management/route.js